import Resource from '@/api/Resource';
import Message from '@/models/Message';
import User from '@/models/User';

export default class Room extends Resource {
  $name = 'rooms';

  $defaults() {
    return {
      id: null,
      name: '',
      private: false,
    };
  }

  $fill({ messages, users }) {
    if (messages) {
      this.messages = Message.collection(messages);
    }

    if (users) {
      this.users = User.collection(users);
    }
  }

  get prettyName() {
    if (this.name) {
      return this.name;
    }

    return `Room #${this.id}`;
  }
}
